import * as T from "../Controls.style";
import * as S from "./RadioControl.style";
import { get } from "lodash";
import { Inputs } from "@/components/atoms/Inputs";
import { Control, Controller } from "react-hook-form";

interface RadioControlProps {
  name: string;
  data?: any;
  size?: "sm" | "md" | "lg";
  width?: string;
  label?: string;
  control: Control<any>;
  required?: boolean;
  disabled?: boolean;
  onChange?: (value: any) => void;
  defaultValue?: string;
}

export const RadioControl = ({
  size,
  name,
  data,
  width,
  label,
  control,
  required,
  onChange,
  defaultValue,
  disabled = false,
}: RadioControlProps) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field, formState }) => (
        <T.Controls>
          <Inputs
            label={label}
            required={required ? required : false}
            width={width}
          >
            <S.InputRadio $size={size}>
              {data.map((item: any, idx: number) => (
                <S.Label key={idx} $size={size}>
                  <input
                    type="radio"
                    name={name}
                    value={item.value}
                    disabled={disabled}
                    onChange={() => {
                      field.onChange(item.value);
                      if (onChange) onChange(item.value);
                    }}
                    checked={field.value === item.value}
                  />
                  {item.displayExpr}
                </S.Label>
              ))}
            </S.InputRadio>
          </Inputs>
          {get(formState.errors, name)?.message && (
            <span>
              <>{get(formState.errors, name)?.message}</>
            </span>
          )}
        </T.Controls>
      )}
    />
  );
};
